"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShoppingBag = exports.useCartMenu = void 0;
const react_1 = require("react");
const shoppingBagReducer_1 = require("../reducers/shoppingBagReducer");
const ShoppingBagProvider_1 = require("../providers/ShoppingBagProvider");
const DEFAULT_TIMEOUT_TO_CLOSE_POPOVER = 7000;
/**
 * Hook para gerenciar o menu e notificador do carrinho, não use este hook para usar o carrinho, use {@link useCart} em vez disso.
 */
const useCartMenu = () => {
    const context = (0, react_1.useContext)(ShoppingBagProvider_1.ShoppingBagContext);
    if (context === undefined) {
        throw new Error('useShoppingBag must be used within a ShoppingBagProvider or CartProvider');
    }
    const { state, dispatch } = context;
    const openPopover = (0, react_1.useCallback)(() => {
        dispatch({ type: shoppingBagReducer_1.ShoppingBagActionTypes.OPEN_POPOVER });
    }, [dispatch]);
    const closePopover = (0, react_1.useCallback)(() => {
        dispatch({ type: shoppingBagReducer_1.ShoppingBagActionTypes.CLOSE_POPOVER });
    }, [dispatch]);
    const notify = (0, react_1.useCallback)(() => {
        openPopover();
    }, [openPopover]);
    const openBag = (0, react_1.useCallback)(() => {
        dispatch({ type: shoppingBagReducer_1.ShoppingBagActionTypes.OPEN_BAG });
    }, [dispatch]);
    const closeBag = (0, react_1.useCallback)(() => {
        dispatch({ type: shoppingBagReducer_1.ShoppingBagActionTypes.CLOSE_BAG });
    }, [dispatch]);
    (0, react_1.useEffect)(() => {
        if (state.isPopoverOpen) {
            const timeout = setTimeout(() => {
                closePopover();
            }, DEFAULT_TIMEOUT_TO_CLOSE_POPOVER);
            return () => clearTimeout(timeout);
        }
    }, [closePopover, notify, state.isPopoverOpen]);
    return {
        timer: DEFAULT_TIMEOUT_TO_CLOSE_POPOVER,
        state,
        notify,
        closePopover,
        openBag,
        closeBag,
    };
};
exports.useCartMenu = useCartMenu;
/**
 * @deprecated Use {@link useCart} em vez disso.
 */
exports.useShoppingBag = exports.useCartMenu;
